// We need an element to throw things like the autocomplete results into
// that is classed correctly
//FIXME:Can we just add this to the DOM without js???
ht.smartuiLegacyAppendable = document.createElement('div');
ht.smartuiLegacyAppendable.id = 'smartuiLegacyAppendable';
ht.smartuiLegacyAppendable.className = 'ht-legacy';
